import { useCallback, useState } from 'react'
const useToggle = (initValue = false) => {
    const [value, setValue] = useState(initValue)

    const toggle = useCallback(
        () => {
            setValue(value => !value)
        }, 
        []
    )

    return [value, toggle]
}

export default useToggle